import type { z } from '@repo/schema'
import type { GetLoadTypeSchema } from '@repo/schema/load'

export const groupLoadTypes = (loadTypes: z.output<typeof GetLoadTypeSchema>[]) => {
  const anyLoadType = loadTypes.find(item => item.slug === 'any')
  const otherLoadTypes = loadTypes.filter(item => item.slug !== 'any')

  return {
    grouped: [
      {
        hiddenDefault: false,
        options: [...(anyLoadType ? [anyLoadType] : []), ...otherLoadTypes.slice(0, 3)],
      },
      {
        hiddenDefault: true,
        label: 'More' as const,
        options: otherLoadTypes.slice(3),
      },
    ],
    raw: loadTypes,
  }
}
